import clsx from 'clsx';
import { ACCEPTED_LOCALES, DEFAULT_LOCALE } from 'constants/locales';
import useCookie from 'hooks/useCookie';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
import { getLocaleInfo } from './getLocaleInfo';
import LanguageList from './LanguageList';
import LanguageListItem from './LanguageListItem';
import classes from './LanguagePicker.module.scss';

export type Props = {
  className?: string;
};

export default function LanguagePicker({ className }: Props) {
  const router = useRouter();
  const localeString = router.locale || DEFAULT_LOCALE;
  const locale = getLocaleInfo(router.locale || DEFAULT_LOCALE);
  const [localeOverrideCookie, setLocaleOverrideCookie] = useCookie('NEXT_LOCALE', {
    sameSite: 'None',
    secure: true,
  });
  const [isOpen, setIsOpen] = useState(false);

  function handleLanguagePick(locale: string | undefined) {
    setLocaleOverrideCookie(locale);
    setIsOpen(false);
  }

  useEffect(() => {
    if (
      router.isReady &&
      localeOverrideCookie &&
      ACCEPTED_LOCALES.includes(localeOverrideCookie) &&
      router.locale !== localeOverrideCookie
    ) {
      document.location.href = `/${localeOverrideCookie}${router.asPath}`;
    }
  }, [localeOverrideCookie, router]);

  const langOnly = localeString.split('-')[0];

  return (
    <div className={clsx(classes.root, className)}>
      {isOpen && <LanguageList className={classes.list} onLanguagePick={handleLanguagePick} />}
      {locale && (
        <div className={classes.selector} onClick={() => setIsOpen((prevState) => !prevState)}>
          <LanguageListItem
            languageClassName={classes.selectorListItemLanguage}
            localeInfo={{ ...locale, locale: langOnly }}
            checked={false}
            isDropdownToggle={true}
          />
          {isOpen ? (
            <MdOutlineExpandMore className={classes.icon} />
          ) : (
            <MdOutlineExpandLess className={classes.icon} />
          )}
        </div>
      )}
    </div>
  );
}
